import { IOption } from "../../../../UI/Elements/Forms/interface/IOption";
import { TEXT_ALIGNMENT, ELEMENT_TYPES, ALL_OPTION_OBJ, GRID_CELL_ELEMENT } from "../../configuration";

import { IFormElement } from "../../Interfaces/Form/FormElement/IFormElement";
import { IForm } from "../../Interfaces/Form/IForm";
import { IGridHeader } from "../../Interfaces/Grid/IGridHeader";
import {
	GET_SUBAGENCIES_BY_AGENCY, GET_BRANDS_BY_CLIENT,
	GET_VERTICAL_BY_BRAND
} from "../../../../api/APIPaths/mapping";
import { IStatusIndicator } from "../interface/IStatusIndicator";

export const getGoogleAdsFormConfig_mapper = (formData: any): IForm => {

	const Account: IFormElement = {
		id: "account",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.DISPLAY_ACCOUNT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: false
		},
		errorMessage: "",
		visible: true,
		value: formData.account || null,
		configuration: {
			dataSourceKey: "",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "",
			title: "",
			defaultValue: [],
			allowAll: false,
			parentElements: [],
			apiURL: "",
			readOnly: {
				editForm: true,
				newForm: false
			}
		},
		notification: {
			label: "Manager Account",
			managerId: "managerId",
			managerName: "managerName"
		},
		readOnly: true,
		readOnlyOptions: {
			title: "",
			subtitle: "",
			keys: {
				title: "accountName",
				subtitle: "accountId",
			}
		},
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};


	const Agency: IFormElement = {
		id: "agency",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.agency || null,
		configuration: {
			dataSourceKey: "agencies",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Agency",
			title: "Agency",
			defaultValue: null,
			allowAll: false,
			parentElements: [],
			apiKey: "agency_id",
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const SubAgency: IFormElement = {
		id: "subagency",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: false
		},
		errorMessage: "",
		visible: false,
		value: formData.subagency || null,
		configuration: {
			dataSourceKey: "subagencies",
			dataSource: [],
			isMulti: false,
			isVisible: false,
			multiRows: 2,
			placeholder: "Select SubAgency",
			title: "SubAgency",
			defaultValue: null,
			allowAll: false,
			parentElements: ["agency"],
			apiURL: GET_SUBAGENCIES_BY_AGENCY
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const Market: IFormElement = {
		id: "market",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.market || null,
		configuration: {
			dataSourceKey: "markets",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Market",
			title: "Market",
			defaultValue: null,
			allowAll: false,
			parentElements: [],
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const Client: IFormElement = {
		id: "client",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.client || null,
		configuration: {
			dataSourceKey: "clients",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Client",
			title: "Client",
			defaultValue: null,
			allowAll: false,
			parentElements: [],
			isAsyncSelect: true,
			apiKey: "client_id",
			asyncRequestKey: "client_name",
			apiURL: "api/mapping/v2/client/",
			isCreatableSelect: false,
			tooltip: "This field displays 2500 clients by default. To search a client, type the client's name and select from the dropdown.",
			note: "For adding new clients please contact to <a href='mailTo:gdt-automations-support@groupm.tech'>gdt-automations-support@groupm.tech</a>"
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};
	const Brand: IFormElement = {
		id: "brand",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.brand || null,
		configuration: {
			dataSourceKey: "brands",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Brand",
			title: "Brand",
			defaultValue: null,
			allowAll: false,
			parentElements: ["client"],
			apiURL: GET_BRANDS_BY_CLIENT,
			apiKey: "brand_id",
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const Vertical: IFormElement = {
		id: "vertical",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: false
		},
		errorMessage: "",
		visible: true,
		value: formData.vertical || null,
		configuration: {
			dataSourceKey: "verticals",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Vertical",
			title: "Vertical",
			defaultValue: [],
			allowAll: false,
			parentElements: ["brand"],
			apiURL: GET_VERTICAL_BY_BRAND,
			readOnly: {
				editForm: true,
				newForm: true
			},
			selectValueIfEmpty: {
				valueLabelKey: "None",
				value: null,
			}
		},
		readOnly: true,
		readOnlyOptions: {
			title: "",
			subtitle: "",
			keys: {
				title: "label",
				subtitle: "",
			}
		},
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};


	const IncludeInAdoptionStats: IFormElement = {
		id: "includeInAdoptionStats",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SWITCH,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		visible: true,
		errorMessage: "",
		value: formData.includeInAdoptionStats || true,
		configuration: {
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "",
			title: "Include in Adoption Statistics as part of Usage Dashboard",
			defaultValue: 1,
			dataSourceKey: "",
			allowAll: false,
			parentElements: []
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	return {
		id: "mappingMapperForm",
		title: "",
		isValid: true,
		isVisible: true,
		groups: [{
			id: "mappingMapperFormGroup",
			elements: [Account, Agency, SubAgency, Market, Client, Brand, Vertical, IncludeInAdoptionStats],
			isVisible: true,
			title: ""
		}]
	};
};

export const getGoogleAdsBulkEditFormConfig = (formData: any): IForm => {

	const Account: IFormElement = {
		id: "account",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.DISPLAY_ACCOUNT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: false
		},
		errorMessage: "",
		visible: true,
		value: formData.account || null,
		configuration: {
			dataSourceKey: "",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "",
			title: "",
			defaultValue: [],
			allowAll: false,
			parentElements: [],
			apiURL: "",
			readOnly: {
				editForm: true,
				newForm: false
			}
		},
		notification: {
			label: "Manager Account",
			managerId: "managerId",
			managerName: "managerName"
		},
		readOnly: true,
		readOnlyOptions: {
			title: "",
			subtitle: "",
			keys: {
				title: "accountName",
				subtitle: "accountId",
			}
		},
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};


	const Agency: IFormElement = {
		id: "agency",
		disabled: false,
		isValid: true,
		touched: false,
		groupCategory: "Group1",
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.agency || null,
		configuration: {
			dataSourceKey: "agencies",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Agency",
			title: "Agency",
			defaultValue: null,
			allowAll: false,
			parentElements: [],
			apiKey: "agency_id",
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const SubAgency: IFormElement = {
		id: "subagency",
		disabled: false,
		isValid: true,
		touched: false,
		groupCategory: "Group1",
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: false
		},
		errorMessage: "",
		visible: false,
		value: formData.subagency || null,
		configuration: {
			dataSourceKey: "subagencies",
			dataSource: [],
			isMulti: false,
			isVisible: false,
			multiRows: 2,
			placeholder: "Select SubAgency",
			title: "SubAgency",
			defaultValue: null,
			allowAll: false,
			parentElements: ["agency"],
			apiURL: GET_SUBAGENCIES_BY_AGENCY
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const Market: IFormElement = {
		id: "market",
		disabled: false,
		isValid: true,
		touched: false,
		groupCategory: "Group2",
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.market || null,
		configuration: {
			dataSourceKey: "markets",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Market",
			title: "Market",
			defaultValue: null,
			allowAll: false,
			parentElements: [],
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const Client: IFormElement = {
		id: "client",
		disabled: false,
		isValid: true,
		touched: false,
		groupCategory: "Group3",
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.client || null,
		configuration: {
			dataSourceKey: "clients",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Client",
			title: "Client",
			defaultValue: null,
			allowAll: false,
			parentElements: [],
			isAsyncSelect: true,
			apiKey: "client_id",
			asyncRequestKey: "client_name",
			apiURL: "api/mapping/v2/client/",
			isCreatableSelect: false,
			tooltip: "This field displays 2500 clients by default. To search a client, type the client's name and select from the dropdown.",
			note: "For adding new clients please contact to <a href='mailTo:gdt-automations-support@groupm.tech'>gdt-automations-support@groupm.tech</a>"
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};
	const Brand: IFormElement = {
		id: "brand",
		disabled: false,
		isValid: true,
		touched: false,
		groupCategory: "Group3",
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.brand || null,
		configuration: {
			dataSourceKey: "brands",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Brand",
			title: "Brand",
			defaultValue: null,
			allowAll: false,
			parentElements: ["client"],
			apiURL: GET_BRANDS_BY_CLIENT,
			apiKey: "brand_id",
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const Vertical: IFormElement = {
		id: "vertical",
		disabled: false,
		isValid: true,
		touched: false,
		groupCategory: "Group3",
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: false
		},
		errorMessage: "",
		visible: true,
		value: formData.vertical || null,
		configuration: {
			dataSourceKey: "verticals",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Vertical",
			title: "Vertical",
			defaultValue: [],
			allowAll: false,
			parentElements: ["brand"],
			apiURL: GET_VERTICAL_BY_BRAND,
			readOnly: {
				editForm: true,
				newForm: true
			},
			selectValueIfEmpty: {
				valueLabelKey: "None",
				value: null,
			}
		},
		readOnly: true,
		readOnlyOptions: {
			title: "",
			subtitle: "",
			keys: {
				title: "label",
				subtitle: "",
			}
		},
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};


	const IncludeInAdoptionStats: IFormElement = {
		id: "includeInAdoptionStats",
		disabled: false,
		isValid: true,
		touched: false,
		groupCategory: "Group4",
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		visible: true,
		errorMessage: "",
		value: formData.includeInAdoptionStats || null,
		configuration: {
			dataSourceKey: "includeInAdoptionStats",
			dataSource: [],
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Include in Adoption Statistics",
			title: "Include in Adoption Statistics as part of Usage Dashboard",
			defaultValue: null,
			allowAll: false,
			parentElements: []
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	return {
		id: "mappingMapperForm",
		title: "",
		isValid: true,
		isVisible: true,
		groups: [{
			id: "mappingMapperFormGroup",
			elements: [Account, Agency, SubAgency, Market, Client, Brand, Vertical, IncludeInAdoptionStats],
			isVisible: true,
			title: ""
		}]
	};
};

export const getGoogleAdsFilterFormConfig = (formData: any): IForm => {

	const Status: IFormElement = {
		id: "status",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.status || null,
		configuration: {
			dataSourceKey: "status",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Status(s)",
			title: "Status(s)",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: [],
			apiURL: ""
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};


	const Agency: IFormElement = {
		id: "agencies",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.agency || null,
		configuration: {
			dataSourceKey: "agencies",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Agency(s)",
			title: "Agency(s)",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: [],
			apiKey: "agency_id"

		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	
	const Market: IFormElement = {
		id: "market",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.market || null,
		configuration: {
			dataSourceKey: "markets",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Market(s)",
			title: "Market(s)",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: [],
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const Client: IFormElement = {
		id: "clients",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.client || null,
		configuration: {
			dataSourceKey: "clients",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Client(s)",
			title: "Client(s)",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: [],
			isAsyncSelect: true,
			asyncRequestKey: "client_name",
			apiURL: "api/mapping/v2/client/",
			apiKey: "client_id",
			tooltip: "This field displays 2500 clients by default. To search a client, type the client's name and select from the dropdown."
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false,

	};
	const Brand: IFormElement = {
		id: "brands",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.client || null,
		configuration: {
			dataSourceKey: "brands",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Brand(s)",
			title: "Brand(s)",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: ["clients"],
			isAsyncSelect: true,
			asyncRequestKey: "brand_name",
			apiURL: GET_BRANDS_BY_CLIENT,
			apiKey: "brand_id",
			tooltip: "This field displays 2500 brands by default. To search a brand, type the brand's name and select from the dropdown.",
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};
	const Vertical: IFormElement = {
		id: "verticals",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.client || null,
		configuration: {
			dataSourceKey: "verticals",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Vertical(s)",
			title: "Vertical(s)",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: ["brands"],
			apiURL: GET_VERTICAL_BY_BRAND


		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const MappedBy: IFormElement = {
		id: "mappedby",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.mappedby || null,
		configuration: {
			dataSourceKey: "portalUsers",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Mapped By",
			title: "Mapped By",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: []
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};

	const IncludeInAdoptionStats: IFormElement = {
		id: "includeInAdoptionStats",
		disabled: false,
		isValid: true,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true
		},
		errorMessage: "",
		visible: true,
		value: formData.includeInAdoptionStats || null,
		configuration: {
			dataSourceKey: "includeInAdoptionStats",
			dataSource: [],
			isMulti: true,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Include In Adoption Stats",
			title: "Include in Adoption Statistics as part of Usage Dashboard",
			defaultValue: [ALL_OPTION_OBJ],
			allowAll: true,
			parentElements: [],
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};


	return {
		id: "mappingMapperFilter",
		title: "",
		isValid: true,
		isVisible: true,
		groups: [{
			id: "mappingMapperFilter-group1",
			elements: [Status, Agency, Market, Client, Brand, Vertical, MappedBy, IncludeInAdoptionStats],
			isVisible: true,
			title: ""
		}]
	};
};

export const GOOGLEADS_GRID_HEADERS: IGridHeader[] = [{
	defaultSortBy: false,
	id: "id",
	visible: false,
	title: "",
	type: ELEMENT_TYPES.ID,
	isMulti: false,
	sortingKey: "id",
	disableSorting: true,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	cellStyle: GRID_CELL_ELEMENT.DEFAULT
}, {
	defaultSortBy: true,
	id: "account",
	visible: true,
	title: "Account",
	type: ELEMENT_TYPES.TEXT_INPUT,
	isMulti: false,
	sortingKey: "account",
	disableSorting: false,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	cellStyle: GRID_CELL_ELEMENT.TWO_LINER_TITLE_SUBTITLE,
	cellTwoLiner: {
		titleKey: "accountName",
		subtitleKey: "accountId"
	}
},
{
	defaultSortBy: true,
	id: "status",
	visible: true,
	title: "Status",
	type: ELEMENT_TYPES.TEXT_INPUT,
	isMulti: false,
	width: 80,
	sortingKey: "status",
	disableSorting: false,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	statusIndicator: true,
	cellStyle: GRID_CELL_ELEMENT.DEFAULT
}, {
	defaultSortBy: true,
	id: "agency",
	visible: true,
	title: "Agency",
	type: ELEMENT_TYPES.TEXT_INPUT,
	isMulti: false,
	sortingKey: "agency",
	disableSorting: false,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	cellStyle: GRID_CELL_ELEMENT.TWO_LINER_TITLE_SUBTITLE,
	cellTwoLiner: {
		titleKey: "agencyName",
		//subtitleKey: "subagencyName"
	}
}, {
	defaultSortBy: true,
	id: "market",
	visible: true,
	title: "Market",
	type: ELEMENT_TYPES.TEXT_INPUT,
	isMulti: false,
	sortingKey: "market",
	disableSorting: false,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	cellStyle: GRID_CELL_ELEMENT.TWO_LINER_TITLE_SUBTITLE,
	cellTwoLiner: {
		titleKey: "marketName",
		subtitleKey: "marketCode"
	}
}, {
	defaultSortBy: true,
	id: "client",
	visible: true,
	title: "Client / Brand",
	type: ELEMENT_TYPES.TEXT_INPUT,
	isMulti: false,
	sortingKey: "client",
	disableSorting: false,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: true,
	cellStyle: GRID_CELL_ELEMENT.TWO_LINER_TITLE_SUBTITLE,
	cellTwoLiner: {
		titleKey: "clientName",
		subtitleKey: "brandName"
	}
},
{
	defaultSortBy: true,
	id: "vertical",
	visible: true,
	title: "Vertical",
	type: ELEMENT_TYPES.TEXT_INPUT,
	isMulti: false,
	sortingKey: "vertical",
	disableSorting: false,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	cellStyle: GRID_CELL_ELEMENT.TWO_LINER_TITLE_SUBTITLE,
	cellTwoLiner: {
		titleKey: "verticalName",
		subtitleKey: ""
	}
}, {
	defaultSortBy: true,
	id: "mappedby",
	visible: true,
	title: "Mapped by",
	type: ELEMENT_TYPES.TEXT_INPUT,
	isMulti: true,
	sortingKey: "mappedby",
	width: 125,
	disableSorting: false,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	cellStyle: GRID_CELL_ELEMENT.TWO_LINER_TITLE_SUBTITLE,
	cellTwoLinerTooltip: true,
	cellTwoLiner: {
		titleKey: "name",
		subtitleKey: "mappedDate",
		tooltip: "email"
	},

}, {
	defaultSortBy: true,
	id: "includeInAdoptionStats",
	visible: true,
	title: "Dashboard",
	width: 105,
	type: ELEMENT_TYPES.SWITCH,
	isMulti: false,
	sortingKey: "includeInAdoptionStats",
	disableSorting: true,
	alignment: TEXT_ALIGNMENT.DEFAULT,
	showHideText: false,
	tooltip: "Include in Adoption Statistics as part of Usage Dashboard",
	cellStyle: GRID_CELL_ELEMENT.DEFAULT
}
];

export const getAccountsDropdown = (value: any, dataSource: IOption[]): IFormElement => {
	return {
		id: "accounts",
		disabled: false,
		isValid: false,
		touched: false,
		type: ELEMENT_TYPES.SELECT_INPUT,
		validations: {
			isEmail: false,
			isNumber: false,
			required: true,
		},
		errorMessage: "",
		visible: true,
		value: value || null,
		configuration: {
			dataSourceKey: "agencies",
			dataSource: dataSource,
			isMulti: false,
			isVisible: true,
			multiRows: 2,
			placeholder: "Select Agency",
			title: "Agency",
			defaultValue: null,
			allowAll: false,
			parentElements: [],
		},
		readOnly: false,
		apiError: "",
		highlightRemovedOptionError: "",
		highlightRemovedOption: false
	};
};

export const statusIndicator = (statusName: string): string => {
	const StatusConfig: IStatusIndicator | any = {
		"Mapped*": "Indicates the account is mapped but the account mapping has discrepancy. Click the edit action to correct.",
		Mapped: "Indicates that the account is mapped.",
		Unmapped: "Indicates that the account is not mapped.",
		Inactive: "Indicates that the account is removed from the selected Manager Account."
	};
	return StatusConfig[statusName];
};

export const UI_AUTH_HEADER_NAMES = {
	GOOGLE: "x-portal-google-auth-refresh-token",
	FACEBOOK: "x-portal-facebook-auth-access-token"
};